<div class="row">
    <p-table [columns]="columns" class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
        styleClass="p-datatable-gridlines" [value]="visaList" dataKey="id" >
        <ng-template pTemplate="header" let-columns>
            <tr class="text-uppercase">
                <th *ngFor="let col of columns">
                    {{col.header}}                  
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-visaList let-expanded="expanded" let-columns="columns">
            <tr>               
                <td *ngFor="let col of columns">
                    <span *ngIf="col.columnType === 'text'">
                        {{(visaList[col.columnDef])?visaList[col.columnDef]: '--'}}
                    </span>
                    <span *ngIf="col.columnType === 'options' && col.header ==='VISA TYPE/IMMIGIRATION CATAGORY'">
                        {{(visaList['visaType'])?visaList['visaType']: visaList['immCategory']}}
                    </span>
                    <span *ngIf="col.columnType === 'options' && col.header ==='PETITION TYPE/IMMIGIRATION CLASSIFICATION'">
                        {{(visaList['petitionType'])?visaList['petitionType']: visaList['immClassification']}}
                    </span>
                    <span *ngIf="col.columnType === 'date' && col.columnDef ==='publishedOn'">                    
                        {{(visaList['publishedOn'])? (visaList['publishedOn'] | date: 'MM/dd/yyyy'): (visaList['previousPublishedOn'])? (visaList['previousPublishedOn'] | date: 'MM/dd/yyyy'):'--'}}
                    </span>
                    <span *ngIf="col.columnType === 'action'">   
                          <mat-icon class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                            <mat-icon>settings</mat-icon>
                            <mat-icon>keyboard_arrow_down</mat-icon>
                          </mat-icon>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="handleView(visaList.visaId)">
                                View</button>
                            <button mat-menu-item (click)="handleEdit(visaList.visaId)" *ngIf="isDevMode">
                              Edit</button>
                              <!-- <button *ngIf="visaList['publishedOn']" mat-menu-item (click)="handleRepublish(visaList.visaId)">
                                Re-Publish</button> -->
                              <button mat-menu-item *ngIf="(visaList['publishedOn'] || visaList['previousPublishedOn']) && isDevMode" (click)="handleDuplicate(visaList.visaId)">
                                Duplicate</button>
                              <button mat-menu-item (click)="handleDelete(visaList.visaId)" *ngIf="isDevMode">
                                Delete</button>
                          </mat-menu>
                    </span>
                </td>
            </tr>
        </ng-template>
        {{columns.length}}
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length">No Data</td>
            </tr>
        </ng-template>       
    </p-table>      
    <p-paginator class="col no-padding" align="center" [rows]="recordsPerPage" *ngIf="visaList?.length > 0" [rowsPerPageOptions]="[25,50,100]"
        [totalRecords]="totalCount"  (onPageChange)="handlePageChange($event)"></p-paginator>
    <!-- <div class="col" align="center" *ngIf="visaList?.length == 0" class="mt-4 text-center">No Data</div>   -->
</div>
<p-confirmDialog header="Delete"></p-confirmDialog>
